// extracted by mini-css-extract-plugin
export default {"contain":"zone_contain__AOW+C","heading":"zone_heading__Xwbzq","head":"zone_head__MXg6V","cardsContainer":"zone_cardsContainer__Fa9QU","card":"zone_card__+cMLq"};